<template>
    <b-button @click="toggle" variant="link" class="change-icon-button">
        <b-icon :icon="isActive ? iconB : iconA" :style="iconStyle"/>
        <span v-if="isActive">
            <slot name="active"></slot>
        </span>
        <span v-else>
            <slot name="inactive"></slot>
        </span>
    </b-button>
</template>

<script>
export default {
    name: 'ChangeIcon',
    props: {
        iconA: { type: String, required: true },
        iconB: { type: String, required: true },
        modelValue: { type: Boolean, default: false },
        iconColor: { type: String, default: 'white' },
        hoverColor: { type: String, default: 'black' },
    },
    emits: ['update:modelValue', 'change', 'activate', 'deactivate'],
    computed: {
        isActive() {
            return this.modelValue;
        },
        iconStyle(){
            return {
                color: `${this.iconColor} !important`,
                fill: `${this.iconColor} !important`,
                '--hover-color': this.hoverColor
            }
        }
    },
    methods: {
        toggle() {
            const newValue = !this.modelValue;
            
            // Emitir el cambio de valor
            this.$emit('update:modelValue', newValue);
            
            // Emitir evento de cambio con el nuevo valor
            this.$emit('change', newValue);
            
            // Emitir eventos específicos según el estado
            if (newValue) {
                this.$emit('activate');
            } else {
                this.$emit('deactivate');
            }
        }
    }
}
</script>

<style scoped>
.change-icon-button {
    border: none !important;
    background: transparent !important;
    box-shadow: none !important;
    padding: 0.25rem 0.5rem;
}

.change-icon-button:hover {
    background: transparent !important;
    transform: none;
}

.change-icon-button:focus {
    border: none !important;
    box-shadow: none !important;
    background: transparent !important;
}

.change-icon-button:active {
    background: transparent !important;
    transform: none;
}

.change-icon-button svg {
    transition: all 0.2s ease;
    cursor: pointer;
}

.change-icon-button:hover svg {
    color: var(--hover-color) !important;
    fill: var(--hover-color) !important;
    transform: scale(1.1);
}
</style>